/**
 * 联网占比组件
 * zxw
 * 2024-08-09
 */

import React, { useEffect, useState } from 'react';
import Pie from '@ant-design/plots/es/components/pie';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders, winWidth } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const IDINC = (props) => {
    const [data, setData] = useState([]);

    const getData = () => {
        const params = {
            'mod': 'IDINC',
        }
        $.ajax({
            url: `${CNF.api}report/intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
            dataType: 'JSON',success:function(data){
                if(data.res === 0){
                    if(data.dat.length>0){
                        //  计算百分比
                        let t = 0;
                        for(let i=0; i<data.dat.length; i++){
                            t += data.dat[i].count;
                        }
                        let newData = data.dat;
                        for(let j=0; j<data.dat.length; j++){
                            let p = 100 * parseFloat(data.dat[j].count/t);
                            newData[j].type = data.dat[j].type;
                            newData[j].percent = p.toFixed(2);
                        }
                        setData(newData);
                        props.setIDINCData(newData);
                    }
                }
            }
        })
    }

    useEffect(()=>{
        getData();
    },[]);

    const config = {
        data: data,
        width: (winWidth - 40) / 4,
        // padding: [0,0,0,0],
        paddingTop: 20,
        paddingRight: 10,
        angleField: 'count',
        colorField: 'type',
        radius: 0.8,
        // innerRadius: 0.6,
        percent: true,
        title : {
            title: '主机联网占比',
            size: 12,
            style: {
                titleFontSize: 12,
                titleFill: '#fff',
                align: 'center',
            },
        },
        scale: {
            color: { range: ['#04C0C2','#167DF6']}
        },
        label: {
            text: (d) => `${d.type} ${d.percent}%`,
            position: 'outside',
            transform: [{ type: 'overlapDodgeY' }],
            fill: '#fff',
            strokeOpacity: 1,
            fillOpacity: 1,
            connectorStroke: '#fff'
        },
        legend: false,
        tooltip: {
            title: 'type',
            items: [
                { field: 'count', name: '数量', valueFormatter: (value) => `${value} 个`}, 
                { field: 'percent', name: '占比', color: 'red',valueFormatter: (value) => `${value} %`}],
        },
        interaction: {
            elementHighlight: true,
        },
        state: {
            inactive: { opacity: 0.5 },
            active: {
                style: {
                    stroke: '#fff',
                    lineWidth: 1,
                },
            },
        },
        // animate: { 
        //     enter: { 
        //         type: 'waveIn',
        //         duration: 3000,
        //     }
        // }
    };
    return <Pie width={'100%'} {...config} />
}

export default IDINC;